<!--
 * @Author: your name
 * @Date: 2022-04-27 09:05:07
 * @LastEditTime: 2022-04-28 20:38:33
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \buyer_vue\src\views\account-center\showMyAccount.vue
-->
/*
 * @Author: 刘枫
 * @Date: 2020-10-28 15:19:39
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-09-03 15:48:31
 */

<template>
  <div>
    <div class="header">
      <img src="../../assets/images/account_logo.png" width="200">
    </div>
    <div class="cz-con">
      <div class="inner">
        <h2>合伙人积分(配送)</h2>
        <div class="content">
          <form action="api/user/transfer?tokenId=798cc3d3-56b0-44b2-848a-a3d6d306f253" name="transferForm"
            class="alipayform" method="POST" target="_blank">
            <div class="element">
              <div class="etitle">消费合伙人积分（配送） : {{consume}}</div>
            </div>
            <div class="element">
              <div class="etitle">创投合伙人积分（配送） : {{shareholding}}</div>
            </div>
            <div class="element">
              <div class="etitle">网点合伙人积分（配送） : {{provincialShare}}</div>
            </div>
            <div class="element">
              <div class="etitle">高管合伙人积分（配送） : {{manageShare}}</div>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>

</template>
<script>

import { getMyPoint } from 'api/user';
// import layer from 'vue-layer';
export default {
  data() {
    return {
      consume: "",
      transModel: "",
      shareholding: "",
      provincialShare: "",
      manageShare: ""
    }
  },
  created() {
    this.consume = this.$route.query["consume"];
    this.transModel = this.consume;
    this.returnIndex();
  },
  methods: {
    returnIndex() {
      // let postBody = this.$Rsa.encrypt(JSON.stringify({ loginName: getSession('userName') }))
      getMyPoint({}).then(res => {
        if (res.resCode == 1) {
          this.consume = res.data.consume;
          this.shareholding = res.data.shareholding;
          this.provincialShare = res.data.provincialShare;
          this.manageShare = res.data.manageShare;
        } else {
          layer.msg(res.resDesc, { icon: 2 });
          return;
        }
      });
    }
  }
}
</script>
<style scoped lang="less">
@import "../../assets/css/showMyAccount.less";
</style>



// WEBPACK FOOTER //
// showMyAccount.vue?b1e0e8ba